// frontend/src/pages/NotFound.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        
        {/* Ícone Animado */}
        <div className="relative inline-block mb-8">
            <div className="text-9xl opacity-20 filter blur-sm animate-pulse">💧</div>
            <div className="absolute inset-0 flex items-center justify-center text-8xl">😕</div>
        </div>

        <h1 className="text-6xl font-black text-sabesp-blue mb-4">404</h1>
        <h2 className="text-2xl font-bold text-gray-700 mb-4">Página Não Encontrada</h2>
        
        <p className="text-gray-500 mb-8 leading-relaxed">
          Parece que a página que você está procurando não existe ou foi movida. Verifique o endereço ou volte para o mapa.
        </p>

        <button 
          onClick={() => navigate('/')} 
          className="px-8 py-4 bg-sabesp-blue text-white font-bold rounded-xl shadow-lg hover:bg-blue-600 transition-all transform hover:-translate-y-1 hover:shadow-xl w-full"
        >
          Voltar ao Início
        </button>
      </div>
    </div>
  );
}

export default NotFound;